import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "guide",
  class: "noselect"
}
const _hoisted_2 = { class: "guide-title-container s-bg-1" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "guide-title d-flex align-items-center justify-content-center" }, "Your QuickSource Guide is here to help you.")
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "guide-body-container" }
const _hoisted_7 = { class: "guide-steps" }
const _hoisted_8 = ["data-bs-original-title", "aria-label"]
const _hoisted_9 = { class: "row flex-nowrap" }
const _hoisted_10 = { class: "col-1 status-icon" }
const _hoisted_11 = { class: "col-11 guide-item-details" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = ["innerHTML", "onClick"]
const _hoisted_14 = ["href", "target"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "guide-video hover" }, null, -1)
const _hoisted_16 = [
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", {
        class: "guide-close hover",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeGuide()))
      }, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.guide, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "guide-item",
            key: item.id,
            "data-bs-html": "true",
            "data-bs-toggle": "tooltip",
            "data-bs-placement": "top",
            "data-bs-original-title": item.message,
            "aria-label": item.message
          }, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("i", {
                    class: _normalizeClass(_ctx.hasCompleted(item.completed))
                  }, null, 2)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", {
                    class: "guide-header",
                    innerHTML: item.header
                  }, null, 8, _hoisted_12),
                  (item.showMe)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "guide-show-me",
                        innerHTML: item.showMe,
                        onClick: ($event: any) => (_ctx.showMeWhere(item.id))
                      }, null, 8, _hoisted_13))
                    : _createCommentVNode("", true),
                  (item.video)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        class: "guide-video-atag",
                        href: _ctx.getLink(item.video),
                        target: _ctx.getTarget()
                      }, _hoisted_16, 8, _hoisted_14))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ], 8, _hoisted_8))
        }), 128))
      ])
    ])
  ]))
}